import React from 'react';
import { Card, Typography, Skeleton } from 'antd';

const { Text, Title } = Typography;

/**
 * Dashboard stat card matching main app's Card pattern.
 *
 * Props:
 *   title    — label string
 *   value    — main value (string or number)
 *   icon     — React node (antd icon)
 *   color    — icon/accent color (CSS color or var())
 *   loading  — show skeleton
 *   suffix   — small text after value
 */
const StatCard = ({ title, value, icon, color = 'var(--varexe-primary)', loading = false, suffix }) => {
  return (
    <Card
      style={{
        borderRadius: 8,
        border: '1px solid var(--varexe-border-color)',
        boxShadow: 'var(--varexe-box-shadow-sm)',
      }}
      styles={{ body: { padding: '20px 24px' } }}
    >
      {loading ? (
        <Skeleton active paragraph={{ rows: 1 }} />
      ) : (
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          {icon && (
            <div style={{
              width: 48,
              height: 48,
              borderRadius: 10,
              background: `color-mix(in srgb, ${color} 12%, white)`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 22,
              color: color,
              flexShrink: 0,
            }}>
              {icon}
            </div>
          )}
          <div>
            <Text type="secondary" style={{ fontSize: 12, display: 'block', marginBottom: 2 }}>
              {title}
            </Text>
            <Title level={3} style={{ margin: 0, fontSize: 24, fontFamily: 'Poppins, sans-serif', color: 'var(--varexe-gray-900)' }}>
              {value ?? '—'}
              {suffix && <Text type="secondary" style={{ fontSize: 14, fontWeight: 400, marginLeft: 4 }}>{suffix}</Text>}
            </Title>
          </div>
        </div>
      )}
    </Card>
  );
};

export default StatCard;
